import ModalInfo from "./ModalInfo";
export default ModalInfo;
